import React from "react"

const LinkedInIcon = (props) => (
	<svg width={props.size} height={props.size} fill={props.color} stroke={props.color} viewBox="0 0 512 512">
		<path d="M426 0h-340c-47.3 0-86 38.7-86 86v340c0 47.3 38.7 86 86 86h340c47.3 0 86-38.7 86-86v-340c0-47.3-38.7-86-86-86zM192 416h-64v-224h64v224zM160 160c-17.673 0-32-14.327-32-32s14.327-32 32-32 32 14.327 32 32-14.327 32-32 32zM416 416h-64v-128c0-17.673-14.327-32-32-32s-32 14.327-32 32v128h-64v-224h64v39.736c13.199-18.132 33.376-39.736 56-39.736 39.765 0 72 35.817 72 80v144z" />
	</svg>
)

export default LinkedInIcon
